import React, { useState } from 'react';
import projectData from '../assets/projectsData.js';

const Projects = () => {
  const [projectsToShow, setProjectsToShow] = useState(5);

  const showMoreProjects = () => {
    setProjectsToShow(prev => prev + 5);
  };

  return (
    <div id="projects" className="bg-dark-blue flex flex-col items-center py-10 lg:py-20">
      <h2 className="text-xl lg:text-2xl font-bold mb-4">Projects</h2>
      <div className="flex flex-wrap justify-around w-full h-full overflow-auto">
        {projectData.slice(0, projectsToShow).map((project, index) => (
          <div
            key={project.title}
            className={`${index % 2 === 0 ? 'text-left' : 'text-right'} mb-6 lg:mb-12 mx-0.5 w-full md:w-1/2 lg:w-1/3 p-6 lg:p-8 bg-dark-gray shadow-lg relative rounded-xl`}
          >
            <div className="image-container flex">
              {project.image && (
                <img
                  src={project.image}
                  alt={project.title}
                  className="absolute bg-dark-gray rounded shadow-lg bottom-0 right-0 mb-[-2%] mr-[-20%] transition-transform duration-300 ease-in-out"
                  style={{ height: '100%', objectFit: 'cover', objectPosition: 'center' }}
                />
              )}
            </div>

            <h3 className="text-lg lg:text-xl font-semibold mb-2">{project.title}</h3>
            <p>
              {project.description.split('\n').map((line, i, arr) =>
                i === arr.length - 1 ? (
                  line
                ) : (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                )
              )}
            </p>
            {project.link && (
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline"
              >
                View Project
              </a>
            )}
          </div>
        ))}
      </div>
      {projectsToShow < projectData.length ? (
        <button onClick={showMoreProjects} className="mt-4 p-2 bg-blue-500 text-white rounded">
          Show More
        </button>
      ) : (
        <p className="mt-4 text-white">More projects on the way!</p>
      )}
    </div>
  );
};

export default Projects;
